/**
 * Proxy to internal urls
 */
export const urlConfig = Object.freeze({
  urlChatbar: '/reference-url/management_chatbot_smart_help/v1/chatbars',
  collaboratorUrl: '/reference-url/consult_data_collaborator/v1/collaborators',
  urlSsoTicket: '/reference-url/auth/oauth/v1/token',
  system_code: '@system_code',
});
